import { useEffect, useState } from 'react'

import { useFetchStorageMutation } from '@redux/api'

import { AutocompleteOption } from '@types'

export const useRosterQualOptions = ({ hideHardCodeFilters }: { hideHardCodeFilters: boolean }) => {
  const [fetchStorage] = useFetchStorageMutation()
  const [options, setOptions] = useState<AutocompleteOption[]>([])
  useEffect(() => {
    if (hideHardCodeFilters) {
      return
    }

    fetchStorage({ objectCode: 'roster-qual' })
      .unwrap()
      .then(res => {
        if (Array.isArray(res)) {
          setOptions(res.map(qual => ({ id: qual['qual_id'], label: qual['qual_name'] })))
        }
      })
  }, [hideHardCodeFilters])

  return options
}
